import type { JSX, ReactNode } from 'react'

export interface KBDProps {
  children: ReactNode
}

export function KBD({ children }: KBDProps): JSX.Element {
  return (
    /* `font-modifier-keys` rather than `font-sans`: a kbd hint is usually a
     * modifier symbol, and DMSans has none of them. */
    <kbd className="pointer-events-none inline-block min-w-6 rounded-sm border border-border bg-card p-1 text-center font-modifier-keys text-xs font-medium text-card-foreground shadow-kbd select-none">
      {children}
    </kbd>
  )
}
